import auth from "./auth";
import blends from "./blends";
import coffeecacao from "./coffeecacao";
import common from "./common";
import dashboard from "./dashboard";
import dds from "./dds";
import error from "./error";
import farm from "./farm";
import oma from "./oma";
import survey from "./survey";
import regionalRiskAssessment from './regionalRiskAssessment'
import indigenous from "./indigenous";

export default {
  ...auth,
  ...coffeecacao,
  ...common,
  ...dashboard,
  ...dds,
  ...error,
  ...farm,
  ...oma,
  ...survey,
  ...blends,
  ...regionalRiskAssessment,
   ...indigenous
};
